import { Injectable } from '@angular/core';
import { T4Box } from '@app/models/payroll/t4-box.model';

@Injectable()
export class T4BoxService {
    t4BoxOptions: T4Box[] = [];

    constructor() {
        // Auto-load boxes based on scope (defaults to secondary for most forms)
        this.load();
    }

    protected load(): void {
        this.loadWithScope('secondary');
    }

    /**
     * Helper to load T4 boxes with a given scope
     * Reduces duplication and ensures consistent fetch/sort logic
     */
    protected loadWithScope(scope: string): void {
        T4Box.where(scope, true)
            .where('without2020', true)
            .limit(100)
            .get()
            .then((t4BoxOptions) => {
                [this.t4BoxOptions] = t4BoxOptions;
                this.t4BoxOptions.sort((t4BoxOption1, t4BoxOption2) =>
                    t4BoxOption1.boxNumber.localeCompare(t4BoxOption2.boxNumber)
                );
            });
    }
}
